import styled from 'styled-components';
import DefaultButton from '../../components/DefaultButton';
import { DefaultCreationFormGroup } from '../../components/DefaultCreationForm';

export const Container = styled.div``;

export const StyledButton = styled(DefaultButton)`
  margin: 0.2rem;
  transition: filter 0.2s;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  &.arrows {
    max-width: 80px;
  }

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`;

export const CustomCreationFormGroup = styled(DefaultCreationFormGroup)`
  margin-top: 40px;
  max-width: 40%;

  > label {
    margin-bottom: 40px;
  }

  > span {
    margin-top: 30px;
    font-style: italic;
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  min-width: 60px !important;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #594aad;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;
